'use client';

import Sidebar from '~/components/sidebar/sidebar';
import NotebookSession from './notebook-session';

const TechnicalSessionContainer = ({ sessionId }: { sessionId: string }) => {
  return (
    <div className="flex flex-row h-full w-full">
      <div className="h-full">
        <Sidebar />
      </div>
      <div className="h-full grow overflow-hidden">
        <NotebookSession sessionId={sessionId} />
      </div>
    </div>
  );
};

export default TechnicalSessionContainer;
